module.exports = __webpack_public_path__ + "assets/images/carrier.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/carrier.png
// module id = 246
// module chunks = 1